import { TableBody, TableCell, TableRow } from '@material-ui/core';
import { OrderDetails } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { ItemRow } from '@/components/modules/Cart/components/OrderLines/components/OrderTable/components/Body/components/ItemRow';
import { TotalAmount } from '@/components/modules/Cart/components/OrderLines/components/OrderTable/components/TotalAmount';
import { useOrderDetails } from '@/components/modules/Cart/components/OrderLines/hooks/useOrderDetails';
import { ItemDetail } from '@/components/shared/components/ItemDetail/ItemDetail';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { useScreen } from '@/hooks/useScreen';

export const Body = ({
  orderDetails,
  tableProps,
}: {
  orderDetails: OrderDetails;
  tableProps: { classes; stickyCellStyle };
}) => {
  const { isMobile } = useScreen();
  const { classes } = tableProps;
  const { DialogComponent, setOpened } = useDialog();

  const [orderItemIndex, setOrderItemIndex] = useState(null);

  const showItemDetails = (index) => {
    setOrderItemIndex(index);
    setOpened(true);
  };

  const { getOrderItemStatus } = useOrderDetails(orderDetails);

  const items = orderDetails.order.items;

  return (
    <>
      <TableBody>
        {items.map((item, index) => (
          <ItemRow
            key={item.id}
            isMobile={isMobile}
            orderDetails={orderDetails}
            showItemDetails={showItemDetails}
            item={item}
            itemIndex={index}
            tableProps={tableProps}
          />
        ))}
        <TableRow className={classes.root}>
          <TotalAmount
            totalAmount={orderDetails.totalOrderAmount}
            currency={orderDetails.currency}
            isMobile={isMobile}
            tableProps={tableProps}
          />
          <TableCell />
        </TableRow>
      </TableBody>
      {orderItemIndex !== null && orderDetails.currency && (
        <DialogComponent>
          <ItemDetail
            currency={orderDetails.currency}
            itemDetail={items[orderItemIndex]}
            itemStatus={getOrderItemStatus(items[orderItemIndex])}
          />
        </DialogComponent>
      )}
    </>
  );
};
